import el from "@cypherpotato/el";
import page from "page";
import { api } from "../../../api";
import { BigTextPreview } from "../../../components/big-text-preview";
import { Button } from "../../../components/button";
import { CodeEditor } from "../../../components/code-editor";
import { CommandBar } from "../../../components/command-bar";
import { Dashboard, DashboardTitle } from "../../../components/dashboard";
import { Editor, EditorDescription, EditorTitle } from "../../../components/editor";
import { TextInput } from "../../../components/form";
import { Icon } from "../../../components/icon";
import { Section } from "../../../components/layout";
import { Link } from "../../../components/link";
import { MutedText, Paragraph } from "../../../components/text";
import { TimeSpanPicker } from "../../../components/time-span-picker";
import { displayFormControl } from "../../../ui/alert";
import { formatDuration } from "../../../ui/format";
import { runOperation } from "../../../ui/operation";
import { ellipsis, valueFrom } from "../../../util";

export default function (ctx) {

    const chatClientId = ctx.params.id;

    function handleSave() {
        const data = {
            tag: valueFrom("sessionTag"),
            expires: valueFrom("sessionExpiration"),
            extraContext: valueFrom("sessionContext")
        };
        
        runOperation("Saving chat session...", async () => {
            await api.postJson(`/api/v1/web-chat-client/${chatClientId}/sessions`, data);
            page(`/dashboard/chat-clients/${chatClientId}/sessions/`);
        });
    }

    return Dashboard(
        Section(
            Link(el.fragment(Icon("arrow-left-line"), "Return back"), null, {
                onClick() {
                    history.go(-1);
                    page();
                }
            })
        ),
        DashboardTitle(
            "New chat session",
            "Crie uma sessão rapidamente abaixo."
        ),
        Section(
            CommandBar(
                Button(Icon("save-line"), "Save session", {
                    onClick() {
                        handleSave();
                    }
                })
            )
        ),
        Section(
            Editor(
                {
                    id: "sessionTag",
                    renderValue(value) {
                        return Button(value && ellipsis(value) || MutedText("Empty"));
                    },
                    manipulateValue(value, callback) {
                        displayFormControl({
                            title: this.editorTitle,
                            message: this.editorParagraphs,
                            formControlItem: TextInput(null, "abc123...", { value }),
                            onConfirm: callback,
                            validate: []
                        })
                    }
                },
                EditorDescription(
                    EditorTitle("Tag"),
                    Paragraph("The tag is an external ID for this key session."),
                    Paragraph("You can specify a user ID, meta-information, or any other information you want to track for this session.")
                )
            ),
            Editor(
                {
                    id: "sessionExpiration",
                    value: 3600,
                    renderValue(value) {
                        return Button(value && formatDuration(value) || MutedText("Empty"));
                    },
                    manipulateValue(value, callback) {
                        displayFormControl({
                            title: this.editorTitle,
                            message: this.editorParagraphs,
                            formControlItem: TimeSpanPicker({ value: value || 3600 }),
                            onConfirm: callback,
                            validate: [
                                [x => x >= 600, "The duration must be greater than or equal to 10 minutes."],
                                [x => x <= 7776000, "The duration must be less than or equal to 90 days."],
                            ]
                        })
                    }
                },
                EditorDescription(
                    EditorTitle("Expiration"),
                    Paragraph("Chat sessions expire. Control the time that this session will be kept on our servers before being considered expired.")
                )
            ),
            Editor(
                {
                    id: "sessionContext",
                    renderValue(value) {
                        return BigTextPreview(value);
                    },
                    manipulateValue(value, callback) {
                        displayFormControl({
                            title: this.editorTitle,
                            message: this.editorParagraphs,
                            formControlItem: CodeEditor({ value }),
                            onConfirm: callback,
                            validate: [
                                [x => x.length <= 4096, "The context must have a maximum of 4,096 characters."],
                            ]
                        })
                    }
                },
                EditorDescription(
                    EditorTitle("Context"),
                    Paragraph("Specify additional context for the model's instructions to understand what this conversation is about, who is talking, etc.")
                )
            )
        )
    )
}